import { Version } from '@hippo/version/version';

export const HIPPO_VERSION = new Version('1.0.0').full;
